module.exports = __webpack_public_path__ + "static/media/Illus-Spring.b5b79a15.png";